import http from './httpRequest.js'

// 路径常量，供 FileUpload 组件的 :action prop 使用
export const IMAGE_UPLOAD_URL = '/api/v1/image/upload'
export const FILE_UPLOAD_URL = '/api/v1/file/upload'

export function uploadImage(formData, params) {
	let url = IMAGE_UPLOAD_URL
	if (params) {
		const query = new URLSearchParams(params).toString()
		url = `${url}?${query}`
	}
	return http.post(url, formData, {
		headers: { 'Content-Type': 'multipart/form-data' }
	})
}

export function uploadFile(formData) {
	return http.post(FILE_UPLOAD_URL, formData, {
		headers: { 'Content-Type': 'multipart/form-data' }
	})
}

// 语音上传（silk 格式，后端校验扩展名与文件头）
export const VOICE_UPLOAD_URL = '/api/v1/voice/upload'

export function uploadVoice(formData) {
	return http.post(VOICE_UPLOAD_URL, formData, {
		headers: { 'Content-Type': 'multipart/form-data' }
	})
}
